// Feature flag keys used in LaunchDarkly.
// Expiry dates are noted and should be monitored to update or remove flags as needed.
// Use long date formats to avoid ambiguity.

// Release flags should be prefixed with "RELEASE_"

export const FEATURE_FLAGS = {
    DATASHARING_DATE_RANGE_DAYS: 'of-cf-datasharing-date-range-260521', // Recommended removal: tba 2026
    RELEASE_PERIOD_TEMPLATES: 'of-cf-release-period-templates-260604', // Recommended removal: tba 2026
    RELEASE_PERIOD_TEMPLATES_IMPORT: 'of-cf-release-period-templates-import-260804', // Recommended removal: November 2026
    RELEASE_ACTIVITY_PLANNING: 'of-cf-release-activity-planning-260727', // Recommended removal: October 2026
    RELEASE_EDITOR_API_CHANGES: 'of-cf-release-editor-api-changes-260813', // Recommended removal: November 2026
    RELEASE_USER_CONFIG_PARAMETERS: 'of-w-release-user-config-parameters-260807', // Recommended removal: November 2026
    RELEASE_EDITOR_TABLE_UPDATE: 'of-w-editor-table-update-260820', // Recommended removal: November 2026
    RELEASE_USER_CONFIG_CUSTOM_CHARTS: 'of-w-release-user-config-custom-charts-260824', // Recommended removal: November 2026
    RELEASE_ATHLETE_GROUPS: 'of-w-athlete-groups-260828', // Recommended removal: November 2026
    EDITOR_WEBGPU_CHART: 'of-cf-editor-webgpu-chart-260901', // Recommended removal: tba 2027
    RELEASE_REPORTING_TABLES_UPDATE: 'of-w-reporting-tables-update-260907', // Recommended removal: December 2026
    RELEASE_CHINA_REGION: 'of-w-release-china-region', // Recommended removal: tba
    RELEASE_UPDATE_SETTINGS_CONNECTIONS: 'of-w-update-settings-connections-261020', // Recommended removal: January 2027
    RELEASE_POSITIONS_SETTINGS: 'of-w-release-positions-settings-261016', // Recommended removal: January 2027
} as const;
